import * as ko from "knockout";


declare module "knockout" {

    // Extends interface of "ko.observableArray.fn" defined in "knockout.d.ts"
    interface ObservableArrayFunctions<T> {
        /**
         * Track changes made to this observable array.
         *
         * @param {any} callback
         *     Function to call when new items are added-to/removed-from the array.
         */
        subscribeWithChanges(callback: (added: T[], removed: T[]) => void): ko.subscription<T[]>;
    }

}


/**
 * Subcribes to an observable array and tracks added/deleted items.
 *
 * @param callback
 *      Called on change with two parameters, (added, deleted), which
 *      contain the added and deleted elements, respectively.
 * @return
 *      The knockout subscription object that can be used to dispose this subscription.
 */
export function subscribeWithChanges<T>(callback: (added: T[], removed: T[]) => void): ko.subscription<T[]> {
    if (typeof callback !== "function") { throw new Error("subscribeWithChanges requires valid callback function"); }

    const self: ko.ObservableArrayFunctions<T> = this;

    let oldArray = self.peek().slice(0);
    return self.subscribe((items) => {
        const changes = ko.utils.compareArrays(oldArray, items),
            added: any[] = [],
            deleted: any[] = [];
        for (const item of changes) {
            switch (item.status) {
            case "added":
                added.push(item.value);
                break;
            case "deleted":
                deleted.push(item.value);
                break;
            default:
                // do nothing
            }
        }
        oldArray = items.slice();
        // call callback function
        if (added.length > 0 || deleted.length > 0) {
            callback(added, deleted);
        }
    });
}


/**
 * Activates the 'subscribeWithChanges' method on observable arrays.
 */
export function activateSubscribeWithChanges(): void {
    if (!ko.observableArray.fn.subscribeWithChanges) {
        ko.observableArray.fn.subscribeWithChanges = subscribeWithChanges;
    }
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/subscribeWithChanges.ts